import { Component, EventEmitter, Input, Output } from '@angular/core';
import { INode } from '../node.interface';


@Component({
  selector: 'ngx-org-chart-node',
  templateUrl: './chart-node.component.html',
  styleUrls: ['./chart-node.component.scss']
})
export class OrgChartNodeComponent {
  @Input() node: INode;
  @Input() hasParent = false;
  @Input() direction: 'vertical' | 'horizontal' = 'vertical';
  @Input('useBadge') useBadge: boolean = false; // 뱃지 사용여부
  @Input('badgeField') badgeField: string = 'depth'; // 뱃지에 표시된 내용
  
  @Output() itemClick = new EventEmitter<any>();
  
  index: number = 0;

  click(node, event) {
    let offsetLeft = 0;
    let offsetTop = 0;
    

    let rect = event.getBoundingClientRect();
    console.debug("clicked org node:", rect.top, rect.right, rect.bottom, rect.left);

    offsetLeft = rect.left;
    offsetTop = rect.top;
    
    const offset = {
      node: node,
      el: event,
      offsetLeft: offsetLeft,
      offsetTop: offsetTop,
    }

    this.itemClick.emit(offset);
  }
}
